import MySettings from "./MySettings";

export default MySettings;
